import { createConfigParametersRepository } from '../../configParametersRepository';
import { createCustomDimensionsRepository } from '../customDimensionsRepository';
import { updateAndSyncDatalayer } from '../tag-commander/datalayer';
import type { ECommerceItem } from '../types';
import { parseCookieDomain } from '../utils/cookie';
import type {
  ECommerce4Item,
  ECommerce4Transaction,
  ProductHandler,
  ProductHandlers,
  TrackECommerceArg,
} from './types';
import { isGa4EcommerceData } from './utils';

export const handleProducts = (
  eCommerceData: TrackECommerceArg | ECommerce4Transaction
) => {
  const productHandler = createProductHandler();
  //TODO: remove this when ga4 is fully implemented
  const products = isGa4EcommerceData(eCommerceData)
    ? eCommerceData.items
    : eCommerceData.products;

  if (products) {
    for (const product of products) {
      productHandler.handleProduct(product);
    }
  }
};

const createProductHandler = () => {
  const customDimensionsRepository = createCustomDimensionsRepository();
  /**
   * An object that maps product names to their respective handlers.
   */
  const productHandlers: ProductHandlers = {
    SUBSCRIPTION: {
      handleProduct: () => {
        const { getTrackingStorageClient } = createConfigParametersRepository();
        const storageClient = getTrackingStorageClient();
        storageClient?.setCookie(
          'ua_dimension31',
          'subscriber',
          30,
          parseCookieDomain()
        );
        updateAndSyncDatalayer({
          user_prime_subscription: 'subscriber',
          subscription: 'subscriber',
        });
        customDimensionsRepository.update({
          unlocked_subscription: 'subscriber',
          subscription: 'subscriber',
        });
      },
    },
  };

  return {
    /**
     * Handles the given product based on its name using the corresponding function
     * defined in "productHandlers".
     *
     * @param {ECommerceItem} product - The product object to handle.
     */
    handleProduct: (product: ECommerceItem | ECommerce4Item) => {
      let productHandler: ProductHandler | null = null;
      //UA FORMAT
      if ('name' in product) {
        productHandler = productHandlers[product.name];
      }
      //GA4 FORMAT
      if ('item_name' in product) {
        productHandler = productHandlers[product.item_name];
      }
      if (!productHandler) {
        return;
      }
      productHandler.handleProduct();
    },
  };
};
